// proceduralLibrary/presets/manifest.js
//
// Manifest for the AI-generated preset wallpaper images (WP-IMG). 12 deck-named
// scenes x 2 takes = 24 presets. Full images (1216x832 webp, ~98KB) live at
// /wallpaper-presets/webp/<file>; 240px thumbnails (~4.5KB) at
// /wallpaper-presets/thumbs/<file>. The picker grid shows THUMBS and applies the
// full webp via the existing image-wallpaper path (currentBg === 2).
//
// Assets copied into public/ from
// specs/media-libraries/assets/wallpaper-presets/ (see raw/manifest.json).

const PUBLIC_BASE = process.env.PUBLIC_URL || "";
export const WEBP_DIR = `${PUBLIC_BASE}/wallpaper-presets/webp`;
export const THUMB_DIR = `${PUBLIC_BASE}/wallpaper-presets/thumbs`;

// [scene-slug, display label] — deck's 12 named scenes.
const SCENES = [
  ["alpine-sunrise", "Alpine sunrise"],
  ["ocean-swell", "Ocean swell"],
  ["forest-mist", "Forest mist"],
  ["city-dusk", "City dusk"],
  ["cherry-blossom", "Cherry blossom"],
  ["lavender-fields", "Lavender fields"],
  ["balloon-morning", "Balloon morning"],
  ["autumn-path", "Autumn path"],
  ["tropical-shore", "Tropical shore"],
  ["rainy-window", "Rainy window"],
  ["winter-pines", "Winter pines"],
  ["golden-meadow", "Golden meadow"],
];

// 24 presets: two takes per scene (t1, t2).
export const PRESETS = SCENES.flatMap(([slug, label]) =>
  [1, 2].map((take) => {
    const file = `${slug}-t${take}.webp`;
    return {
      id: `${slug}-t${take}`,
      scene: slug,
      take,
      label: take === 1 ? label : `${label} II`,
      thumb: `${THUMB_DIR}/${file}`,
      full: `${WEBP_DIR}/${file}`,
    };
  })
);

export const PRESET_BY_ID = PRESETS.reduce((acc, p) => {
  acc[p.id] = p;
  return acc;
}, {});
